<template>
  <el-tooltip content="Add Account" placement="bottom">
    <el-button circle style="width: 35px; height: 35px" @click="navigateCustomer">
      <fa-icon :icon="faUserPlus" class="text-[16px]" />
    </el-button>
  </el-tooltip>
</template>

<script>
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'Customer',
  setup() {
    const router = useRouter()
    const route = useRoute()

    const navigateCustomer = () => {
      router.push({ name: route.meta.type + `/create-account` })
    }
    return {
      faUserPlus,
      navigateCustomer,
    }
  },
}
</script>
